import { combineReducers } from 'redux';

import entities from './entities';
import currentUser from './currentUser';
import snackbar from './snackbar';
import captions from './captions';
import profile from './profile';
import resetPassword from './resetPassword';
import userManager from './userManager';
import cms from './cms';
import cloudStorage from './cloudStorage';
import groupManager from './groupManager';
import socialAccount from './socialAccount';
import fileManager from './fileManager';
import dashboard from './dashboard';
import userReport from './userReport';
import paymentHistory from './paymentHistory';
import schedules from './schedules';
import socialPlatform from './socialPlatform';
import socialPlatformAppKeys from './socialPlatformAppKeys';
import socialPage from './socialPage';
import example from './example';
import fbPosts from './fb-posts';
import fbPages from './fb-pages';
import instaPages from './insta-pages';
import instaPosts from './insta-posts';
import ytChannels from './yt-channels';
import ytVideos from './yt-videos';
import linkedInPages from './linkedin-pages';
import linkedInPosts from './linkedin-posts';
import twitterPages from './twitter-pages';
import twitterPosts from './twitter-posts';
import ytChannelsAnalytics from './yt-channels-analytics';
import ytVideosAnalytics from './yt-videos-analytics';
import facebookPagesAnalytics from './facebook-page-analytics';
import facebookPostsAnalytics from './facebook-post-analytics';
import instagramAccountsAnalytics from './instagram-account-analytics';
import instagramPostsAnalytics from './instagram-post-analytics';
import linkedinPages from './linkedinPages'
import dashboardData from './dashboard-data';
import calendarData from './calendar-data';
import teamManagement from './team-management'
import logsData from './logs-data'
import getYoutubeVideos from './get-youtube-videos'
import getTwitterPosts  from './get-twitter-posts'
import getLinkedInPosts from './get-linkedin-posts'
import publishFbPostsList from './publish-fb-post';
import publishInstaPostsList from './publish-insta-post';
import getPostUserData from './create-new-post';
import fetchUserDetails from './get-user-details';
import getUnpaidInvoice from './getUnpaidInvoice';
import queue from './Queue';
import facebookPageFanOnline from './facebookPageFanOnline';
import fbSummary from './fb-summary';
import instaSummary from './insta-summary';
import instaEngagement from './insta-post-engagement';
import facebookPagePostList from './facebookPagePostList';
import facebookPostEngagement from './faceebookPostEngagement';
import fbPostReach from './fb-post-reach';
import instaFollowers from './insta-followers';
import facebookPostByTypeReducer from './facebookPostByTypeReducer';
import instagramPostAnalyticsPost from './instagramPostAnalyticsPost';
import linkedinShareAnalyticsData from './linkedin-share-analytics';
import linkedinShareListData from './linkedin-share-list';
import fbDemographics from './fbDemographics';
import linkedinVisitorData from './linkedin-visitor';
import ldFollowers from './linkedin-follower'
import ldNewFollowers from './linkedin-new-follower';
import ldDemographics from './linkedin-demographic';
import standardDataReducer from './standardDataReducer';
import ytOverview from './youtube-overview';
import linkedinPageViews from './linkedin-page-views';
import ytReach from './youtube-reach';
import ytEngagement from './ytEngagement';
import ytEngagementExtended from './yt-engagement-extended'
import instaFollowerCountData from './insta-followerCount';
import instaDemographicsData from './insta-demographics';
import instaOnlineFollowersData from './insta-onlineFollower';
import brands from './brands-manager';
import usersQueryData from './users-query'
import fbDashboardPosts from './fb-dashboard-posts';
import instaDashboardPosts from './insta-dashboard-posts';
import youtubeDashboardPosts from './yt-dashboard-posts';
import brandsList from './brandsList';
import notifications from './notifications';
import unreadMention from './unreadMention';
import mentions from './mention';
import drafts from './drafts';
import appData from './appData';
import pinterestAnalytics from './pinterestAnalytics';
import subscription from './subscription';
import userSetting from './userSetting';
import logsManager from './logsManager';
import tooltip from './tooltip';
import textToImageGeneration from './text-to-image-generation';
import textToImageVariation from './text-to-image-variation';
import tiktokSummary from './tiktok-account-summary';
import generateOptimalTimeReducer from './generate-optimal-time';
import tiktokEngagement from './tiktok-post-engagement';
import tiktokDemographicsData from './tiktok-demographics';
import youtubePostStatus from './yt-post-status';

const appReducers = combineReducers({
  subscription,
  example,
  fbPosts,
  fbPages,
  instaPosts,
  instaPages,
  ytChannels,
  ytVideos,
  linkedInPages,
  linkedInPosts,
  twitterPages,
  twitterPosts,
  calendarData,
  ytChannelsAnalytics,
  ytVideosAnalytics,
  facebookPagesAnalytics,
  facebookPostsAnalytics,
  instagramAccountsAnalytics,
  instagramPostsAnalytics,
  entities,
  captions,
  currentUser,
  snackbar,
  profile,
  resetPassword,
  cms,
  userManager,
  socialAccount,
  fileManager,
  groupManager,
  cloudStorage,
  dashboard,
  userReport,
  paymentHistory,
  schedules,
  socialPlatform,
  socialPlatformAppKeys,
  socialPage,
  dashboardData,
  linkedinPages,
  teamManagement,
  publishFbPostsList,
  getYoutubeVideos,
  getTwitterPosts,
  getLinkedInPosts,
  publishInstaPostsList,
  getPostUserData,
  fetchUserDetails,
  logsData,
  facebookPageFanOnline,
  getUnpaidInvoice,
  queue,
  fbSummary,
  facebookPagePostList,
  facebookPostEngagement,
  instaSummary,
  instaEngagement,
  fbPostReach,
  instaFollowers,
  facebookPostByTypeReducer,
  instagramPostAnalyticsPost,
  linkedinShareAnalyticsData,
  linkedinShareListData,
  fbDemographics,
  linkedinVisitorData,
  ldFollowers,
  ldDemographics,
  standardDataReducer,
  ytOverview,
  ldNewFollowers,
  linkedinPageViews,
  ytReach,
  ytEngagement,

  ytEngagementExtended,
  instaFollowerCountData,
  instaDemographicsData,
  instaOnlineFollowersData,
  usersQueryData,
  brands,
  fbDashboardPosts,
  instaDashboardPosts,
  youtubeDashboardPosts,
  brandsList,
  notifications,
  unreadMention,
  mentions,
  drafts,
  appData,
  pinterestAnalytics,
  userSetting,
  logsManager,
  tooltip,
  textToImageGeneration,
  textToImageVariation,
  tiktokSummary,
  generateOptimalTimeReducer,
  tiktokEngagement,
  tiktokDemographicsData,
  youtubePostStatus,
});

export default appReducers;
